/** Google SERP meta description limits (~155 chars / ~985px). */
export const META_DESC_MAX_CHARS = 155;

/** Minimum title length for SERP pixel width (~200px at ~6–7px/char). */
export const SEO_TITLE_MIN_CHARS = 30;

/** Recommended max title length for SERP display. */
export const SEO_TITLE_MAX_CHARS = 60;

export function truncateMetaDescription(text, maxChars = META_DESC_MAX_CHARS) {
  if (!text) return "";
  const normalized = text.trim().replace(/\s+/g, " ");
  if (normalized.length <= maxChars) return normalized;

  const cut = normalized.slice(0, maxChars);
  const lastSpace = cut.lastIndexOf(" ");
  const trimmed =
    lastSpace > maxChars * 0.6 ? cut.slice(0, lastSpace) : cut.slice(0, maxChars - 1);
  const result = trimmed.trim();
  return result.endsWith(".") ? result : `${result}.`;
}

export function fitSeoTitle(text, maxLength = SEO_TITLE_MAX_CHARS) {
  if (!text || text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
}

/**
 * Ensures `<title>` meets minimum SERP length without changing visible page copy.
 */
export function ensureMinSeoTitle(title, fallbackSuffix = " | TINT") {
  if (!title) return fitSeoTitle(`TINT${fallbackSuffix}`);
  if (title.length >= SEO_TITLE_MIN_CHARS) return fitSeoTitle(title);

  const expanded = `${title}${fallbackSuffix}`;
  if (expanded.length >= SEO_TITLE_MIN_CHARS) return fitSeoTitle(expanded);

  return fitSeoTitle(`TINT ${title}`);
}
